import { runDemo } from "../shared/demoRunner";
import { createPolygonScene } from "./scene";

runDemo({ createScene: createPolygonScene });
